export var MISSION_PROGRESS_TIMER_COLORS = {
  REGULAR: '#FFF',
  DANGER_PURPLE: '#FFBCBC',
  DANGER_ORANGE: '#FF9800'
};